var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "delivery-hours-editor",
    "class": {
      'mt-4': !_vm.hideTitle
    }
  }, [!_vm.hideTitle ? _c('h6', {
    staticClass: "text-overline font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$translate('title')))]) : _vm._e(), _c('v-form', {
    ref: "form"
  }, _vm._l(_vm.days, function (day, index) {
    return _c('div', {
      key: day.day,
      staticClass: "delivery-hours-day",
      "class": {
        'delivery-hours-day--first': !index
      }
    }, [_c('v-row', {
      staticClass: "stitch-modal__fields",
      attrs: {
        "dense": "",
        "align": "center"
      }
    }, [_c('v-col', {
      staticClass: "font-weight-bold delivery-hours-day__name",
      attrs: {
        "cols": "12",
        "sm": "2"
      }
    }, [_vm._v(_vm._s(_vm.weekday(day.day)))]), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "7"
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.modes,
        "aria-label": _vm.weekday(day.day),
        "dense": "",
        "outlined": "",
        "hide-details": "auto",
        "disabled": _vm.readonly
      },
      on: {
        "change": function change($event) {
          return _vm.changeMode(day);
        }
      },
      model: {
        value: day.mode,
        callback: function callback($$v) {
          _vm.$set(day, "mode", $$v);
        },
        expression: "day.mode"
      }
    })], 1), index && !_vm.readonly ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "3"
      }
    }, [_c('v-btn', {
      staticClass: "text-none delivery-hours-day__copy",
      attrs: {
        "text": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.copyPrevious(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$translate('copy')))])], 1) : _vm._e()], 1), day.mode === 'slots' ? _c('v-row', {
      staticClass: "delivery-hours-day__slots",
      attrs: {
        "dense": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "7",
        "offset-sm": "2"
      }
    }, [_vm._l(day.slots, function (slot, slotIndex) {
      return _c('v-row', {
        key: slotIndex,
        staticClass: "stitch-modal__fields",
        attrs: {
          "dense": "",
          "align": "start"
        }
      }, [_c('v-col', {
        attrs: {
          "cols": "5"
        }
      }, [_c('v-text-field', {
        attrs: {
          "type": "time",
          "label": _vm.$translate('from'),
          "rules": [_vm.required],
          "dense": "",
          "outlined": "",
          "hide-details": "auto",
          "disabled": _vm.readonly
        },
        on: {
          "input": _vm.emitValue
        },
        model: {
          value: slot.start,
          callback: function callback($$v) {
            _vm.$set(slot, "start", $$v);
          },
          expression: "slot.start"
        }
      })], 1), _c('v-col', {
        attrs: {
          "cols": "5"
        }
      }, [_c('v-text-field', {
        attrs: {
          "type": "time",
          "label": _vm.$translate('to'),
          "rules": [_vm.required, function () {
            return _vm.validSlot(day, slot);
          }],
          "dense": "",
          "outlined": "",
          "hide-details": "auto",
          "disabled": _vm.readonly
        },
        on: {
          "input": _vm.emitValue
        },
        model: {
          value: slot.end,
          callback: function callback($$v) {
            _vm.$set(slot, "end", $$v);
          },
          expression: "slot.end"
        }
      })], 1), !_vm.readonly ? _c('v-col', {
        attrs: {
          "cols": "2"
        }
      }, [_c('v-btn', {
        staticClass: "delivery-hours-day__remove",
        attrs: {
          "icon": "",
          "aria-label": _vm.$translate('remove')
        },
        on: {
          "click": function click($event) {
            return _vm.removeSlot(day, slotIndex);
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("mdi-close")])], 1)], 1) : _vm._e()], 1);
    }), !_vm.readonly && day.slots.length < 12 ? _c('v-btn', {
      staticClass: "text-none mt-1",
      attrs: {
        "text": "",
        "small": "",
        "color": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.addSlot(day);
        }
      }
    }, [_vm._v(_vm._s(_vm.$translate('add')))]) : _vm._e()], 2)], 1) : _vm._e()], 1);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }